import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetWH/Main";
import Form from "./TbSetWH/Form";

// Utils
import { getDataWithComp, getAlert } from "../../../utils/SamuiUtils";
import Navbar from "../../components/Modal/Navbar";
// import { InitialDatatype } from "../../../model/InitialData/InitialDataCreditor";

const TbSetWh = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_AP ทั้งหมด
      const masterList = await getDataWithComp("Tb_Set_WH", "Order By WH_Id");
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");

    setFormData({
      WH_Id: item.WH_Id,
      WH_Code: item.WH_Code,
      WH_Name: item.WH_Name,
      WH_Remark: item.WH_Remark,
      // WH_Branch: item.WH_Branch,
      Comp_Id: item.Comp_Id,
      WH_Status: item.WH_Status,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลคลังสินค้า"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลคลังสินค้า"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetWh;
